/**
 * Search artworks reducers.
 * @module reducers/searchArtworks
 */
import { GET_SEARCH_FILTERS_ARTWORKS } from 'iovisit-museum-theme/actions/getSearchFiltersArtworks';

const initialState = {
  subrequests: {},
};

// /**
//  * Get request key
//  * @function getRequestKey
//  * @param {string} actionType Action type.
//  * @returns {string} Request key.
//  */
// function getRequestKey(actionType) {
//   return actionType.split('_')[0].toLowerCase();
// }
export default function searchFiltersArtworksReducer(
  state = initialState,
  action = {},
  subrequests = {},
) {
  switch (action.type) {
    case `${GET_SEARCH_FILTERS_ARTWORKS}_PENDING`:
      return {
        ...state,
        subrequests: {
          ...state.subrequests,
          [action.subrequest]: {
            ...(state.subrequests[action.subrequest] || {
              data: null,
            }),
            loaded: false,
            loading: true,
            error: null,
          },
        },
      };
    case `${GET_SEARCH_FILTERS_ARTWORKS}_SUCCESS`:
      return {
        ...state,
        subrequests: {
          ...state.subrequests,
          [action.subrequest]: {
            loading: false,
            loaded: true,
            error: null,
            data: action.result,
          },
        },
      };
    case `${GET_SEARCH_FILTERS_ARTWORKS}_FAIL`:
      return {
        ...state,
        subrequests: {
          ...state.subrequests,
          [action.subrequest]: {
            data: null,
            loading: false,
            loaded: false,
            error: action.error,
          },
        },
      };
    default:
      return state;
  }
}
